import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import { darkPalette, lightPalette } from "./palette";
import { typography } from "./typography";
import { darkShadows, lightShadows } from "./shadows";
import { MuiButton } from "./components/button";
import { MuiChip } from "./components/chip";
import { MuiCheckbox } from "./components/checkbox";
import { MuiPagination, MuiPaginationItem } from "./components/pagination";
import {
  MuiFormHelperText,
  MuiInputLabel,
  MuiOutlinedInput,
  MuiTextField,
} from "./components/textField";

export const createAppTheme = (mode: "light" | "dark") => {
  const theme = createTheme({
    direction: "rtl",
    palette: mode === "light" ? lightPalette : darkPalette,
    shadows: mode === "light" ? lightShadows : darkShadows,
    typography,

    shape: {
      borderRadius: 10,
    },

    spacing: 8,

    components: {
      MuiButton,
      MuiChip,
      MuiCheckbox,
      MuiTextField,
      MuiOutlinedInput,
      MuiInputLabel,
      MuiFormHelperText,
      MuiPagination,
      MuiPaginationItem,
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            direction: "rtl",
          },
          body: {
            direction: "rtl",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: "1.5rem",
            padding: "2rem",
            border: "1px solid #e2e8f0",
            boxShadow: "0 20px 50px -12px rgba(27,36,70,0.15)",
          },
        },
      },
    },
  });

  return responsiveFontSizes(theme);
};
